import { RestSlice } from '../../../../../../redux/rest.slice';
import { Resource, localizationService } from 'src/services';
import { FacilityUser } from '@rcp/types';

export const manageFacilityAccessSlice = new RestSlice<FacilityUser>(
	localizationService.getLocalizedString('facilityPortal.settings.users.facilityManageAccess'),
	Resource.ManageAccessFacilityUser
);
export default manageFacilityAccessSlice.rests.reducer;
